// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"64":"94b503ff","539":"25c3ee3a","684":"94513481"}[chunkId] + ".css";
};